import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import * as _ from 'lodash'
import { api } from 'api/integrationAPI'

import { HELVETICA, GRAY } from 'components/styles'
import SimplePagination from 'components/shared/SimplePagination'

const Container = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: solid 0.5px #e8e8e8;
  margin-left: 0.5em;
  margin-right: 0.5em;
`
const ProductsContainer = styled.div`
  margin-top: 5px;
  width: 16em;
  margin-left: 0.5em;
  margin-right: 0.5em;
  word-break: break-all;
  overflow: auto;
  display: flex;
`
const ProductsContainerEmpty = ProductsContainer.extend`
  display: flex;
  justify-content: flex-start;
  ${HELVETICA}
  font-size: 8px;
  font-weight: 600;
  letter-spacing: 0.4px;
  color: ${GRAY};
`
const BottomContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  ${HELVETICA}
  font-size: 8px;
  font-weight: 600;
  letter-spacing: 0.4px;
  color: ${GRAY};
  width: 90%;
`
const ProductImage = styled.img`
  width: 5em;
  height: 5em;
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
  margin-right: 0.5em;
  border-radius: 10%;
`

class IPCProductsTagged extends Component {


  renderProductPreview = (p, i) => {
    const { productsDict } = this.props
    const product = api.getProductInfo(p.info, productsDict)
    const imageUrl = _.get(product, ['details', 'images', 0])
    return (
      <ProductImage
        key={i}
        src={imageUrl}
        role={'presentation'}
      />
    )
  }

  renderProducts = (productsTaggedAmount) => {
    if (productsTaggedAmount > 0) {
      const { products } = this.props
      return (
        <SimplePagination
          ItemsContainer={ProductsContainer}
          items={_.map(products, this.renderProductPreview)}
          itemsVisible={3}
        />
      )
    } else {
      return (
        <ProductsContainerEmpty>Products tagged:</ProductsContainerEmpty>
      )
    }
  }

  render () {
    const { products } = this.props
    const productsTaggedAmount = _.sumBy(products, p => p.info ? 1 : 0)
    return (
      <Container>
        {this.renderProducts(productsTaggedAmount)}
        <BottomContainer>
          {productsTaggedAmount} products tagged
        </BottomContainer>
      </Container>
    )
  }
}

IPCProductsTagged.defaultProps = {
  products: [],
  productsDict: {}
}

IPCProductsTagged.propTypes = {
  products: PropTypes.array,
  productsDict: PropTypes.object
}

export default IPCProductsTagged



// WEBPACK FOOTER //
// ./src/components/editor/insta/instaTagPosts/instaPostCard/IPCProductsTagged.js